<div class="col-lg login-container">
    <div class="logo" aria-label="noovle" [inlineSVG]="'assets/img/NGM3OGEyYmYtZDJkOC0zMzEyLThjOWUtYzRjNjZmOTY5M2UxNjY5ODY3ODU0NDM.svg'"></div>
    <span class="col-lg title">
        Polaris
    </span>
    <span class="btn-wrapper">
            <div id="googleBtn">
            </div>
    </span>
    <div class="logoCmyk" aria-label="noovle" [inlineSVG]="'assets/img/M2QxNGUxZDItZjljMS0zMGUyLThhOTYtYmE0NTYzNWFlMDMwNDQ5MTI4MjYwMjM.svg'"></div>
</div>